import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";

/**
 * Sticky Note — Nota visual no canvas (nao executavel).
 * Sem handles de entrada/saida. Apenas documentacao.
 *
 * data.noteText: string — conteudo da nota
 * data.noteColor: string — cor de fundo (#FFF9C4, #DCEDC8, #F8BBD0, #E1F5FE, #F3E5F5)
 */
const NOTE_COLORS = {
  yellow: { bg: "#FFF9C4", border: "#FFF176", text: "#5D4037" },
  green: { bg: "#DCEDC8", border: "#AED581", text: "#33691E" },
  pink: { bg: "#F8BBD0", border: "#F48FB1", text: "#880E4F" },
  blue: { bg: "#E1F5FE", border: "#81D4FA", text: "#01579B" },
  purple: { bg: "#F3E5F5", border: "#CE93D8", text: "#4A148C" },
};

const StickyNoteNode = memo(({ id, data, selected }) => {
  const text = data?.noteText || "Nota...";
  const colorKey = data?.noteColor || "yellow";
  const palette = NOTE_COLORS[colorKey] || NOTE_COLORS.yellow;

  return (
    <div
      style={{
        background: palette.bg,
        border: `2px solid ${selected ? "#1976d2" : palette.border}`,
        borderRadius: 8,
        padding: "12px 16px",
        minWidth: 160,
        maxWidth: 320,
        boxShadow: selected
          ? "0 0 0 2px #1976d2"
          : "2px 3px 8px rgba(0,0,0,0.08)",
        cursor: "grab",
        transition: "box-shadow 0.15s, border-color 0.15s",
        position: "relative",
      }}
    >
      {/* "Fold" corner effect */}
      <div style={{
        position: "absolute",
        top: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "0 20px 20px 0",
        borderColor: `transparent ${palette.border} transparent transparent`,
        borderRadius: "0 6px 0 0",
        opacity: 0.5,
      }} />

      {/* Header */}
      <div style={{
        fontSize: 10,
        fontWeight: 700,
        color: palette.text,
        opacity: 0.5,
        textTransform: "uppercase",
        letterSpacing: "0.08em",
        marginBottom: 6,
      }}>
        NOTA
      </div>

      {/* Content */}
      <div style={{
        fontSize: 13,
        lineHeight: 1.5,
        color: palette.text,
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
      }}>
        {text}
      </div>
    </div>
  );
});

StickyNoteNode.displayName = "StickyNoteNode";
export default StickyNoteNode;
